<template>
    <div class="update">
        <HeaderReturn :title="id == 0 ? '修改登录密码' : id == 1 ? '找回密码' : id == 2 ? '修改交易密码' : '重置交易密码'"></HeaderReturn>

        <div class="safety_ul">
            <el-form :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top"
                :model="formLabelAlign">
                <el-form-item :label="id == 0 ? '旧密码' : id == 1 ? '账号' : id == 2 ? '原始密码' : '助记词'" prop="usedPassword">
                    <el-input v-model="formLabelAlign.usedPassword"
                        :placeholder="id == 0 ? '请输入旧密码' : id == 1 ? '请输入账号' : id == 2 ? '请输入原始密码' : '请输入助记词'"></el-input>
                </el-form-item>
                <el-form-item :label="id == 0 ? '新密码' : id == 1 ? '助记词' : id == 2 ? '新密码' : '新密码'" prop="password">
                    <el-input :show-password='true' type="password" v-model="formLabelAlign.password"
                        :placeholder="id == 0 ? '请输入新密码' : id == 1 ? '请输入助记词' : id == 2 ? '请输入新密码' : '请输入新密码'"></el-input>
                </el-form-item>
                <el-form-item :label="id == 0 ? '确认密码' : id == 1 ? '新密码' : id == 2 ? '确认密码' : '确认新密码'"
                    prop="confirmPassword">
                    <el-input :show-password='true' type="password" v-model="formLabelAlign.confirmPassword"
                        :placeholder="id == 0 ? '请确认密码' : id == 1 ? '请输入新密码' : id == 2 ? '请确认密码' : '请确认新密码'"></el-input>
                </el-form-item>
                <p style="color: #f89b19;font-size: 12px;">*为确保账户安全，请勿设置过于简单的密码</p>
                <el-form-item>
                    <div class="safety_btn">
                        <el-button :loading="IsLoading" type="primary" @click="submitForm('ruleForm')">确定</el-button>


                    </div>


                </el-form-item>
            </el-form>


        </div>






    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon } from 'vant';
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import {
    mainApiData
} from '@/request/api.js'
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            TeamList: [
                {
                    txt: "修改登录密码",
                    id: 0,
                    path: '/system/update'

                },
                {
                    txt: "充值登录密码",
                    id: 1,
                    path: '/system/update'
                },
                {
                    txt: "修改交易密码",
                    id: 2,
                    path: '/system/update'
                },
                {
                    txt: "重置交易密码",
                    id: 3,
                    path: '/system/update'
                }
            ],
            id: 0,
            formLabelAlign: {
                usedPassword: '',
                password: '',
                confirmPassword: ''
            },
            rules: {
                usedPassword: [
                    { required: true, message: '请输入', trigger: 'blur' },

                ],
                region: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],

                tyconfirmPassworde: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],

            },
            IsLoading: false



        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
        this.id = JSON.parse(this.$route.query.id);
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.IsLoading = true;
                    if (this.id == 0) {
                        // 修改登录密码
                        mainApiData.UpPassword(this.formLabelAlign).then((res) => {
                            if (res.data.code == 200) {
                                this.$toast('修改成功');
                                var that = this;
                                localStorage.removeItem("TOKEN");
                                sessionStorage.removeItem("ms_user");
                                this.$router.push('/member/login')
                                this.IsLoading = false;
                            } else {
                                this.$toast(res.data.msg);
                                this.IsLoading = false;
                            }

                        })
                        this.IsLoading = false;
                    } else if (this.id == 1) {
                        let params = {
                            account: this.formLabelAlign.usedPassword,//账户
                            password: this.formLabelAlign.confirmPassword,//确认密码
                            token: this.formLabelAlign.password,//助记词
                        }
                        // 重置登录密码
                        mainApiData.FindPassword(params).then((res) => {
                            if (res.data.code == 200) {
                                this.$toast('重置成功');
                                var that = this;
                                localStorage.removeItem("TOKEN");
                                sessionStorage.removeItem("ms_user");
                                this.$router.push('/member/login')
                                this.IsLoading = false;
                            } else {
                                this.$toast(res.data.msg);
                                this.IsLoading = false;
                            }

                        })
                        this.IsLoading = false;
                    } else if (this.id == 2) {
                        let params = {
                            usedJyPassword: this.formLabelAlign.usedPassword,//原始密码
                            confirmJyPassword: this.formLabelAlign.confirmPassword,//确认密码
                            JyPassword: this.formLabelAlign.password,//新密码
                        }
                        // 修改交易密码
                        mainApiData.JyPassword(params).then((res) => {
                            if (res.data.code == 200) {
                                this.$toast('修改成功');
                                this.IsLoading = false;
                                this.Clert();
                            } else {
                                this.$toast(res.data.msg);
                                this.IsLoading = false;
                            }

                        })
                        this.IsLoading = false;
                    } else if (this.id == 3) {
                        let params = {
                            confirmJyPassword: this.formLabelAlign.confirmPassword,//确认交易密码
                            JyPassword: this.formLabelAlign.password,//新密码
                            token: this.formLabelAlign.usedPassword,//助记词
                        }
                        // 重置交易密码
                        mainApiData.FindJyPassword(params).then((res) => {
                            if (res.data.code == 200) {
                                this.$toast('重置成功');
                                this.IsLoading = false;
                                this.Clert();
                            } else {
                                this.$toast(res.data.msg);
                                this.IsLoading = false;
                            }

                        })
                        this.IsLoading = false;
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        Clert() {
            this.formLabelAlign = {
                usedPassword: '',
                password: '',
                confirmPassword: ''
            }
        },
        goLink(path, item) {
            if (path) {
                this.$router.push({
                    path,
                    query: {
                        id: JSON.stringify(item),
                    }
                });
            } else {
                // 暂未开放
                this.$toast(this.$t('orePond.a42'));
            }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.update {
    margin: 50px 10px;

    ::v-deep .van-nav-bar__title {
        color: #fff;
    }

    .safety_btn {
        /* Frame 147 */


        /* Auto layout */

        // display: flex;
        // flex-direction: row;
        // justify-content: center;
        // align-items: center;
        // padding: 10px;
        // gap: 10px;

        // position: absolute;
        // width: 345px;
        // height: 42px;
        // left: 15px;
        // top: 735px;

        /* 黄/主题 */
        position: absolute;
        top: 300px;
        width: 100%;
        // background: #f89b19;
        border-radius: 4px;
        color: #FFFFFF;

        .el-button {


            background: #f89b19;
            border: 0;
            width: 100%;
        }
    }



    .safety_grid {

        ul {
            display: grid;
            justify-content: space-between;
            grid-template-columns: 25% 25% 25% 25%;
            text-align: center;

            li {
                margin-top: 17px;

                img {
                    // margin: 10px 0;
                }

                p {
                    // padding: 8.74px 0px 15px 0;
                    color: #fff;
                    font-size: 12px;
                }
            }

            // align-items: center;
        }
    }

    .safety_ul {
        ::v-deep .el-form-item__label {
            padding: 0;
            color: #fff;

        }

        ::v-deep .el-form-item__label:before {
            display: none;
        }

        ::v-deep .el-input__inner {
        background: transparent;
                border: 1px solid #f89b19;
                color: #fff;
        }

    }

}
</style>